import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function ShareOptions({ data, eleRef }) {
    var url;
    if(data.hasOwnProperty("url")){
        url = data.url;
    } else {
        url = data.articleUrl;
    }
    return (
        <div className="sharing-options">
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareArticle('facebook', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareArticle('twitter', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareArticle('pintrest', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareArticle('whatsapp', url)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        </div>
    );
}
